module.exports = {
  serverHostUrl: 'https://server.staging.krispsystems.net',
  accessToken: ''
}
